export default __webpack_public_path__ + "static/media/corner-1.44e8a57b.png";